<template>
    <div class="pix-overview" v-if="isPixPayment">
        <div class="overview-container pix-overview__container">
            <div class="pix-overview__info">
                <div class="pix-overview__icon">
                    <img src="@/assets/img/payment-types/pix.svg" alt="pix" tabindex="0" />
                </div>

                <div class="pix-overview__description" tabindex="0">
                    {{ selectedPaymentMethod.Description }}
                </div>
            </div>

            <div class="pix-overview__price" tabindex="0">
                <p>
                    1x
                    <span v-text="$ml.get('of')" />
                    R$ {{ installmentPrice }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
  import PaymentTypes from '@/models/PaymentTypes';
  import { mapGetters } from 'vuex';

  export default {
      computed: {
        ...mapGetters({
            installmentPrice: 'payment/getFormattedInstallmentPrice',
            selectedPaymentMethod: 'payment/getSelectedPaymentMethod'
        }),

        isPixPayment: self =>
          self.selectedPaymentMethod &&
          (self.selectedPaymentMethod.PaymentType == PaymentTypes.PIX),
      }
  };
</script>

<style lang="scss" scoped>
  .pix-overview {

    &__container {
          display: flex;
          align-items: center;
          justify-content: space-between;

      }

      &__info {
          display: flex;
          align-items: center;
      }

      &__icon {
          margin-right: 12px;
          
          @media screen and (min-width: 1025px) {
            margin-right: 20px;
          }

          img {}
      }

      &__description {
          font-size: 16px;
          font-weight: 500;
          line-height: 16px;
          color: #000;
      }

      &__price {

          p {
            font-size: 16px;
            font-weight: 500;
            line-height: 16px;
            color: #000;
            margin: 0;
          }

          span {}
      }

  }
</style>
